import { InvoicePaymentRequest } from "libs/models/invoice";
import { ValidationModel } from "libs/models/validate-model";
import { InvoicesStore } from "store/slices/invoices";
import { decimalNumberRegex, numberRegex } from "utils/regex";
import translate from "utils/translations";

export const validateInvoicePaymentState = (
  state: InvoicesStore
): ValidationModel<InvoicePaymentRequest> => {
  let validationModel = {} as ValidationModel<InvoicePaymentRequest>;
  if (!state.isValidating) {
    return validationModel;
  }

  if (
    state.paymentRequest.amount === undefined ||
    state.paymentRequest.amount === ""
  ) {
    validationModel.amount = translate(
      "Required_Text",
      "This field is required"
    );
  }
  if (
    state.paymentRequest.amount !== undefined &&
    !decimalNumberRegex.test(state.paymentRequest.amount.toString())
  ) {
    validationModel.amount = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.paymentRequest.referenceNumber === undefined ||
    state.paymentRequest.referenceNumber === ""
  ) {
    validationModel.referenceNumber = translate(
      "Required_Text",
      "This field is required"
    );
  }
  return validationModel;
};
